import isMountedMixin from 'vue/mixins/is-mounted';


export default function(watchProp) {
    return {
        mixins: [
            isMountedMixin,
        ],
        props: {
            passiveMode: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                state: {
                    [watchProp]: this[watchProp],
                },
            };
        },
        methods: {
            onRequestChange(payload) {
                this.$emit('request-change', payload);
            },
            change(payload) {
                this.state[watchProp] = payload;
                this.$emit('change', payload);
            },
        },
        mounted() {
            // NOTE: The component handles its state by itself when `passiveMode` is false
            if (this.passiveMode) {
                this.$watch(watchProp, this.change);
            } else {
                this.$on('request-change', this.change);
            }
        },
    };
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/ui-pattern/index.js